// Port of legacy bop-ui helpers/json.ts (the questionnaires-tab
// copy in src/features/user-console/tabs/questionnaires/json.ts rewires here later).

/** True for objects/arrays AND for strings that JSON.parse to a non-null object */
export const isJsonObject = (value: unknown): boolean => {
  if (typeof value !== 'string') return typeof value === 'object' && value !== null;
  try {
    const parsed: unknown = JSON.parse(value);
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }
};

/** bop-api values arrive as objects or JSON strings depending on the producer — parse strings, pass everything else through */
export const parseJsonIfString = (value: unknown): unknown => {
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value) as unknown;
  } catch {
    return value;
  }
};
